import { createAction, props } from "@ngrx/store";

export const getLocalesList = createAction(
  "[Locales] Get All Locales Action",
  props<{ options: any }>()
);
export const loadLocalesList = createAction(
  "[Locales] Load All Locales List Action",
  props<{ response: any[] }>()
);
export const getLocale = createAction(
  "[Locales] Get Locale Action",
  props<{ code: string }>()
);
export const loadLocale = createAction(
  "[Locales] Load Locale Action",
  props<{ response: any }>()
);
export const resetLocaleState = createAction(
  "[Locales] Reset Locales State Action"
);
export const updateLocale = createAction(
  "[Locales] Update Locale Action",
  props<{ locale: any }>()
);
export const createLocale = createAction(
  "[Locales] Create Locale Action",
  props<{ locale: any }>()
);
export const getExcelLocalesList = createAction(
  "[Locales] Get All Locales Excel List Action",
  props<{ options: any }>()
);
export const loadExcelLocalesList = createAction(
  "[Locales] Load All Locales Excel List Action",
  props<{ response: any[] }>()
);
export const getLocalesTableConfig = createAction(
  "[Locales] Get Locales Table Configuration Action",
  props<{ options: any }>()
);
export const loadLocalesTableConfig = createAction(
  "[Locales] Load Grades Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveLocalesTableConfig = createAction(
  "[Locales] Save Locales Table Configuration Action",
  props<{ config: any }>()
);
export const localeLoadEnd = createAction("[Locales] Load Locale End Action");
export const resetLocale = createAction("[Locales] Reset Locale Action");
export const resetCreation = createAction("[Locales] Reset Creation Action");
